import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, EditIcon, Text } from '@mercai/clever'
import { CustomAccordion } from '@/components'

import { ProfilePaymentPreferencesProps } from './payment-preferences.type'
import styles from './payment-preferences.module.css'
import { checkIfPaymentPreferencesIsComplete } from '../../general.constants'

export const ProfilePaymentPreferences = ({
  profile,
  onClickEdit,
}: ProfilePaymentPreferencesProps) => {
  const { t: tEnums } = useTranslation('enums')
  const { t } = useTranslation('screenProfileShow')

  const [activeItems, setActiveItems] = useState(['directions'])

  const isComplete = checkIfPaymentPreferencesIsComplete(profile)

  return (
    <div className={styles.core}>
      <CustomAccordion
        activeItems={activeItems}
        setActiveItems={setActiveItems}
        id="directions"
        title={`3. ${t('generalViewGeneralInformationPaymentPreferencesTitle')}`}
        isComplete={isComplete}
      >
        <div className={styles['info-block']}>
          <div className={styles['info-row']}>
            <div className={styles['info-row-content']}>
              <Text className={styles['info-item']}>
                <strong>{t('generalViewPaymentSPEILabel')}:</strong>{' '}
                {profile?.financeProfile?.speiGatewayAccountId
                  ? profile?.financeProfile?.speiGatewayAccountId
                  : '-'}
              </Text>

              <Text className={styles['info-item']}>
                <strong>{t('generalViewPaymentMethodsLabel')}:</strong>{' '}
                {profile?.financeProfile?.enabledPaymentMethods
                  ?.map((form) =>
                    tEnums(`financial_profile_payment_forms_${form}`),
                  )
                  ?.join(', ') || []}
              </Text>

              <Text className={styles['info-item']}>
                <strong>{t('generalViewPaymentFormsLabel')}:</strong>{' '}
                {profile?.financeProfile?.enabledPaymentForms
                  ?.map((form) =>
                    tEnums(`financial_profile_payment_forms_${form}`),
                  )
                  ?.join(', ') || []}
              </Text>

              {/*
              WE WILL ADD THIS PART IN THE FUTURE

              <Text className={styles['info-item']}>
                <strong>{t('generalViewBuyDaysLabel')}:</strong>{' '}
                {profile?.companyName}
              </Text>

              <Text className={styles['info-item']}>
                <strong>{t('generalViewPayDaysLabel')}:</strong>{' '}
                {profile?.companyName}
              </Text>

              <Text className={styles['info-item']}>
                <strong>{t('generalViewCreditsLabel')}:</strong>{' '}
                {profile?.companyName}
              </Text> */}
            </div>

            <Button
              variant="secondary"
              className={styles.edit}
              size="small"
              onClick={onClickEdit}
            >
              <EditIcon />
            </Button>
          </div>
        </div>
      </CustomAccordion>
    </div>
  )
}
